import { useEffect, useState } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiVideo } from 'react-icons/fi';
import api from '../../api/client';

export default function AdminCursos() {
    const [cursos, setCursos] = useState([]);
    const [profesores, setProfesores] = useState([]);
    const [modal, setModal] = useState(null);
    const [modalVideos, setModalVideos] = useState(null);
    const [cargando, setCargando] = useState(true);

    const cargar = async () => {
        setCargando(true);
        const [c, p] = await Promise.all([api.get('/cursos'), api.get('/admin/profesores')]);
        setCursos(c.data.cursos || []);
        setProfesores(p.data.profesores || []);
        setCargando(false);
    };
    useEffect(() => { cargar(); }, []);

    const eliminar = async (id) => {
        if (!window.confirm('¿Eliminar curso?')) return;
        await api.delete(`/admin/cursos/${id}`);
        cargar();
    };

    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h1 style={{ margin: 0, fontSize: 24 }}>Cursos</h1>
                <button className="btn btn-primario" onClick={() => setModal({})}>
                    <FiPlus /> Nuevo curso
                </button>
            </div>

            <table className="tabla">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Profesor</th>
                        <th>Categoria</th>
                        <th>Nivel</th>
                        <th>Videos</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {cursos.map(c => (
                        <tr key={c.id}>
                            <td>{c.nombre}</td>
                            <td>{c.profesor_nombre || '-'}</td>
                            <td>{c.categoria || '-'}</td>
                            <td style={{ textTransform: 'capitalize' }}>{c.nivel}</td>
                            <td>{c.total_videos}</td>
                            <td style={{ display: 'flex', gap: 6 }}>
                                <button className="icon-btn" onClick={() => setModalVideos(c)} title="Videos"><FiVideo /></button>
                                <button className="icon-btn" onClick={() => setModal(c)} title="Editar"><FiEdit2 /></button>
                                <button className="icon-btn" onClick={() => eliminar(c.id)} style={{ color: 'var(--error)' }} title="Eliminar"><FiTrash2 /></button>
                            </td>
                        </tr>
                    ))}
                    {cursos.length === 0 && (
                        <tr><td colSpan="6" style={{ textAlign: 'center', padding: 24, color: 'var(--texto-suave)' }}>Sin cursos</td></tr>
                    )}
                </tbody>
            </table>

            {modal && <ModalCurso curso={modal} profesores={profesores} cerrar={() => setModal(null)} onGuardado={cargar} />}
            {modalVideos && <ModalVideos curso={modalVideos} cerrar={() => { setModalVideos(null); cargar(); }} />}
        </div>
    );
}

function ModalCurso({ curso, profesores, cerrar, onGuardado }) {
    const [datos, setDatos] = useState({
        nombre: curso?.nombre || '',
        descripcion: curso?.descripcion || '',
        profesor_id: curso?.profesor_id || curso?.profesor_id || '',
        categoria: curso?.categoria || '',
        nivel: curso?.nivel || 'principiante',
        duracion_horas: curso?.duracion_horas || 0,
        imagen_portada: curso?.imagen_portada || '',
        activo: curso?.activo !== undefined ? curso.activo : 1
    });
    const [error, setError] = useState('');

    const guardar = async (e) => {
        e.preventDefault();
        try {
            if (curso.id) {
                await api.put(`/admin/cursos/${curso.id}`, datos);
            } else {
                await api.post('/admin/cursos', datos);
            }
            onGuardado();
            cerrar();
        } catch (err) {
            setError(err.response?.data?.error || 'Error');
        }
    };

    return (
        <div className="modal-bg">
            <div className="modal" style={{ maxWidth: 640 }}>
                <h2>{curso.id ? 'Editar' : 'Nuevo'} curso</h2>
                {error && <div className="error-msg">{error}</div>}
                <form onSubmit={guardar}>
                    <div className="form-group">
                        <label>Nombre del curso</label>
                        <input className="input" value={datos.nombre} onChange={e => setDatos({ ...datos, nombre: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Descripcion</label>
                        <textarea className="input" rows={3} value={datos.descripcion} onChange={e => setDatos({ ...datos, descripcion: e.target.value })} />
                    </div>
                    <div className="auth-grid-2">
                        <div className="form-group">
                            <label>Profesor</label>
                            <select className="input" value={datos.profesor_id} onChange={e => setDatos({ ...datos, profesor_id: e.target.value })}>
                                <option value="">-- Selecciona --</option>
                                {profesores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Categoria</label>
                            <input className="input" value={datos.categoria} onChange={e => setDatos({ ...datos, categoria: e.target.value })} />
                        </div>
                    </div>
                    <div className="auth-grid-2">
                        <div className="form-group">
                            <label>Nivel</label>
                            <select className="input" value={datos.nivel} onChange={e => setDatos({ ...datos, nivel: e.target.value })}>
                                <option value="principiante">Principiante</option>
                                <option value="intermedio">Intermedio</option>
                                <option value="avanzado">Avanzado</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Duracion (horas)</label>
                            <input type="number" step="0.5" className="input" value={datos.duracion_horas} onChange={e => setDatos({ ...datos, duracion_horas: e.target.value })} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>URL imagen de portada (opcional)</label>
                        <input className="input" value={datos.imagen_portada} onChange={e => setDatos({ ...datos, imagen_portada: e.target.value })} placeholder="https://..." />
                    </div>
                    {curso.id && (
                        <div className="form-group">
                            <label>
                                <input type="checkbox" checked={!!datos.activo} onChange={e => setDatos({ ...datos, activo: e.target.checked ? 1 : 0 })} />
                                {' '}Curso activo (visible para usuarios)
                            </label>
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <button type="button" className="btn btn-fantasma" onClick={cerrar}>Cancelar</button>
                        <button type="submit" className="btn btn-primario">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function ModalVideos({ curso, cerrar }) {
    const [videos, setVideos] = useState([]);
    const [editando, setEditando] = useState(null);

    const cargar = async () => {
        const r = await api.get(`/cursos/${curso.id}`);
        setVideos(r.data.videos || []);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { cargar(); }, []);

    const eliminar = async (id) => {
        if (!window.confirm('¿Eliminar video?')) return;
        await api.delete(`/admin/videos/${id}`);
        cargar();
    };

    return (
        <div className="modal-bg">
            <div className="modal" style={{ maxWidth: 720 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>Videos: {curso.nombre}</h2>
                    <button className="btn btn-fantasma" onClick={cerrar}>Cerrar</button>
                </div>
                <button className="btn btn-primario" onClick={() => setEditando({ secuencia: videos.length + 1 })} style={{ marginBottom: 14 }}>
                    <FiPlus /> Agregar video
                </button>

                <table className="tabla">
                    <thead>
                        <tr><th>#</th><th>Titulo</th><th>Tipo</th><th>Duracion</th><th></th></tr>
                    </thead>
                    <tbody>
                        {videos.map(v => (
                            <tr key={v.id}>
                                <td>{v.secuencia}</td>
                                <td>{v.titulo}</td>
                                <td style={{ textTransform: 'capitalize' }}>{v.tipo}</td>
                                <td>{Math.round((v.duracion_segundos || 0) / 60)} min</td>
                                <td style={{ display: 'flex', gap: 6 }}>
                                    <button className="icon-btn" onClick={() => setEditando(v)}><FiEdit2 /></button>
                                    <button className="icon-btn" onClick={() => eliminar(v.id)} style={{ color: 'var(--error)' }}><FiTrash2 /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {editando && (
                    <FormVideo
                        video={editando}
                        cursoId={curso.id}
                        cerrar={() => setEditando(null)}
                        onGuardado={() => { setEditando(null); cargar(); }}
                    />
                )}
            </div>
        </div>
    );
}

function FormVideo({ video, cursoId, cerrar, onGuardado }) {
    const [datos, setDatos] = useState({
        titulo: video?.titulo || '',
        descripcion: video?.descripcion || '',
        secuencia: video?.secuencia || 1,
        duracion_segundos: video?.duracion_segundos || 0,
        tipo: video?.tipo || 'leccion'
    });
    const [archivo, setArchivo] = useState(null);
    const [subiendo, setSubiendo] = useState(false);
    const [error, setError] = useState('');

    const guardar = async (e) => {
        e.preventDefault();
        if (!video.id && !archivo) { setError('Selecciona un archivo .mp4'); return; }
        setSubiendo(true);
        try {
            const form = new FormData();
            form.append('titulo', datos.titulo);
            form.append('descripcion', datos.descripcion);
            form.append('secuencia', datos.secuencia);
            form.append('duracion_segundos', datos.duracion_segundos);
            form.append('tipo', datos.tipo);
            if (archivo) form.append('archivo', archivo);

            if (video.id) {
                await api.put(`/admin/videos/${video.id}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
            } else {
                await api.post(`/admin/cursos/${cursoId}/videos`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
            }
            onGuardado();
        } catch (err) {
            setError(err.response?.data?.error || 'Error al guardar');
        } finally {
            setSubiendo(false);
        }
    };

    return (
        <div className="modal-bg">
            <div className="modal">
                <h2>{video.id ? 'Editar' : 'Nuevo'} video</h2>
                {error && <div className="error-msg">{error}</div>}
                <form onSubmit={guardar}>
                    <div className="form-group">
                        <label>Titulo</label>
                        <input className="input" value={datos.titulo} onChange={e => setDatos({ ...datos, titulo: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Descripcion</label>
                        <textarea className="input" rows={2} value={datos.descripcion} onChange={e => setDatos({ ...datos, descripcion: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <label>Archivo de video (.mp4) {video.id && '— deja vacio para no cambiar'}</label>
                        <input
                            type="file"
                            accept="video/mp4,video/*"
                            className="input"
                            style={{ padding: '8px' }}
                            onChange={e => setArchivo(e.target.files[0] || null)}
                            required={!video.id}
                        />
                        {video.id && video.video_url && (
                            <small style={{ color: 'var(--texto-suave)' }}>Video actual: {video.video_url.split('/').pop()}</small>
                        )}
                    </div>
                    <div className="auth-grid-2">
                        <div className="form-group">
                            <label>Secuencia (orden)</label>
                            <input type="number" className="input" value={datos.secuencia} onChange={e => setDatos({ ...datos, secuencia: parseInt(e.target.value) || 1 })} />
                        </div>
                        <div className="form-group">
                            <label>Duracion (segundos)</label>
                            <input type="number" className="input" value={datos.duracion_segundos} onChange={e => setDatos({ ...datos, duracion_segundos: parseInt(e.target.value) || 0 })} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Tipo</label>
                        <select className="input" value={datos.tipo} onChange={e => setDatos({ ...datos, tipo: e.target.value })}>
                            <option value="introduccion">Introduccion</option>
                            <option value="leccion">Leccion</option>
                            <option value="final">Cierre</option>
                        </select>
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <button type="button" className="btn btn-fantasma" onClick={cerrar} disabled={subiendo}>Cancelar</button>
                        <button type="submit" className="btn btn-primario" disabled={subiendo}>
                            {subiendo ? 'Subiendo...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
